export default __webpack_public_path__ + "static/media/sort-me-chat-telegram.e0989025.jpg";